<script>

    import { replace, location } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'
    import { fly } from 'svelte/transition'

    import StorageService from '../$services/storage.service'

    const navSections = [
        {
            label: 'Principal',
            items: [
                { view: 'graphics',  permission: 'GraphicsView',  label: 'Gráficas',  icon: 'fa-chart-bar'   },
                { view: 'quotations', permission: 'QuotationsView', label: 'Cotizaciones', icon: 'fa-calculator' },
                { view: 'shipments', permission: 'ShipmentsView', label: 'Envíos',    icon: 'fa-paper-plane' },
                { view: 'users',     permission: 'UsersView',     label: 'Usuarios',  icon: 'fa-users'       },
            ],
        },
        {
            label: 'Finanzas',
            items: [
                { view: 'wallets',  permission: 'UsersView.Wallet.View',   label: 'Saldos',     icon: 'fa-wallet'              },
                { view: 'accounts', permission: 'UsersView.Accounts.View', label: 'Cuentas',  icon: 'fa-file-invoice-dollar' },
                { view: 'credits',  permission: 'UsersView.Credits.View',  label: 'Créditos', icon: 'fa-credit-card'         },
                { view: 'invoices', permission: 'UsersView.Invoices.View', label: 'Facturas', icon: 'fa-file-invoice' },
                { view: 'charges',     permission: 'UsersView.Charges.View',  label: 'Cargos',      icon: 'fa-file-invoice'        },
                { view: 'overweights', permission: 'UsersView.Charges.View',  label: 'Sobrepesos',  icon: 'fa-weight'              },
                { view: 'refunds',  permission: 'UsersView.Charges.View',  label: 'Reembolsos',  icon: 'fa-undo'                },
                { view: 'stp',      permission: 'StpView',                 label: 'STP',         icon: 'fa-university'          },
            ],
        },
        {
            label: 'Seguimiento',
            items: [
                { view: 'pickups',       permission: 'TracingsView.Pickups.View',       label: 'Recolecciones',  icon: 'fa-box-open'     },
                { view: 'shopify',       permission: 'TracingsView.Shopify.View',       label: 'Shopify',        icon: 'fa-shopping-bag' },
            ],
        },
        {
            label: 'Configuración',
            items: [
                { view: 'notices',   permission: 'SettingsView.Notices.View',   label: 'Avisos',      icon: 'fa-sticky-note' },
                { view: 'tips',      permission: 'SettingsView.Tips.View',      label: 'Tips',        icon: 'fa-lightbulb'   },
                { view: 'prices',    permission: 'UsersView.Prices.View',       label: 'Precios',     icon: 'fa-dollar-sign' },
            ],
        },
        {
            label: 'Sistema',
            items: [
                { view: 'errors', permission: 'ErrorsView', label: 'Errores', icon: 'fa-exclamation-triangle' },
            ],
        },
    ]

    function sectionHasItems(section) {
        return section.items.some(({ permission }) => isPermission($adminStore, permission))
    }

    let mobileOpen = false

    function showView(view) {
        replace(`#/${view}`)
        mobileOpen = false
    }

    function onLogout() {
        StorageService.deleteItem('user')
        StorageService.deleteItem('access')
        replace('#/')
    }

    $: user = StorageService.getItem('user') ?? {}
    $: userInitial = user?.name ? user.name.charAt(0).toUpperCase() : 'A'

</script>

<style>

    .sidebar {
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        width: 240px;
        background: #ffffff;
        border-right: 1px solid #e8e8e8;
        display: flex;
        flex-direction: column;
        z-index: 30;
        overflow-y: auto;
    }

    .sidebar-nav {
        flex: 1;
        overflow-y: auto;
        padding: 8px 12px;
    }

    .sidebar-nav::-webkit-scrollbar {
        width: 4px;
    }

    .sidebar-nav::-webkit-scrollbar-thumb {
        background: #e0e0e0;
        border-radius: 2px;
    }

    .nav-section-label {
        font-size: 10px;
        font-weight: 600;
        letter-spacing: 0.8px;
        color: #a0a0a0;
        text-transform: uppercase;
        padding: 12px 8px 6px;
    }

    .nav-section-label:first-child {
        padding-top: 4px;
    }

    .nav-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 9px 10px;
        border-radius: 8px;
        cursor: pointer;
        color: #3a3a3a;
        font-size: 14px;
        font-weight: 500;
        transition: background 0.15s ease, color 0.15s ease;
        margin-bottom: 2px;
        user-select: none;
    }

    .nav-item:hover {
        background: #f4f4f4;
        color: #1a1a1a;
    }

    .nav-item:hover .nav-icon {
        color: #1a1a1a;
    }

    .nav-item.active {
        background: var(--color-primary, #098E37);
        color: var(--color-secondary, #ffffff);
    }

    .nav-item.active .nav-icon,
    .nav-item.active:hover .nav-icon {
        color: var(--color-secondary, #ffffff);
    }

    .nav-icon {
        width: 18px;
        text-align: center;
        color: #888;
        font-size: 14px;
        flex-shrink: 0;
        transition: color 0.15s ease;
    }

    .sidebar-footer {
        flex-shrink: 0;
        padding: 12px 16px;
        border-top: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .user-avatar {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background: var(--color-primary, #098E37);
        color: var(--color-secondary, #fff);
        font-size: 13px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .user-info {
        flex: 1;
        min-width: 0;
    }

    .user-name {
        font-size: 13px;
        font-weight: 600;
        color: #1a1a1a;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .user-email {
        font-size: 11px;
        color: #a0a0a0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .logout-btn {
        flex-shrink: 0;
        cursor: pointer;
        color: #a0a0a0;
        font-size: 15px;
        padding: 4px;
        border-radius: 4px;
        transition: color 0.15s;
    }

    .logout-btn:hover {
        color: #1a1a1a;
    }

    .brand-logo-img {
        display: block;
        max-height: 92px;
        max-width: 100%;
        width: auto;
        object-fit: contain;
    }

    .brand-logo-img--compact {
        max-height: 36px;
    }

    .brand-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 16px 18px;
        flex-shrink: 0;
    }

    .mobile-topbar {
        display: none;
        background: #ffffff;
        border-bottom: 1px solid #e8e8e8;
        padding: 0 16px;
        height: 56px;
        align-items: center;
        justify-content: space-between;
        position: sticky;
        top: 0;
        z-index: 30;
    }

    .mobile-logo {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .mobile-logo-text {
        font-size: 16px;
        font-weight: 700;
        color: #1a1a1a;
    }

    .hamburger-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 8px;
        border-radius: 6px;
        color: #3a3a3a;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background 0.15s;
    }

    .hamburger-btn:hover {
        background: #f4f4f4;
    }

    .drawer-backdrop {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.35);
        z-index: 31;
    }

    .drawer {
        position: fixed;
        left: 0;
        top: 0;
        height: 100vh;
        width: 260px;
        background: #ffffff;
        z-index: 32;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        box-shadow: 4px 0 24px rgba(0, 0, 0, 0.12);
    }

    .drawer-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 18px 16px;
        border-bottom: 1px solid #e8e8e8;
        flex-shrink: 0;
    }

    .drawer-logo {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .drawer-logo-text {
        font-size: 16px;
        font-weight: 700;
        color: #1a1a1a;
    }

    .drawer-close {
        background: none;
        border: none;
        cursor: pointer;
        color: #888;
        font-size: 18px;
        padding: 4px 6px;
        border-radius: 6px;
        line-height: 1;
        transition: color 0.15s, background 0.15s;
    }

    .drawer-close:hover {
        color: #1a1a1a;
        background: #f4f4f4;
    }

    .drawer-nav {
        flex: 1;
        overflow-y: auto;
        padding: 8px 12px;
    }

    .drawer-footer {
        flex-shrink: 0;
        padding: 12px 16px;
        border-top: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    @media (max-width: 862px) {
        .sidebar {
            display: none;
        }

        .mobile-topbar {
            display: flex;
        }
    }

</style>

<div class="sidebar">

    <div class="brand-wrapper">
        <img src="images/brand.png" alt="Logisbox" class="brand-logo-img" />
    </div>

    <nav class="sidebar-nav">
        {#each navSections as section}
            {#if sectionHasItems(section)}
                <div class="nav-section-label">{section.label}</div>
                {#each section.items as { view, permission, label, icon }}
                    {#if isPermission($adminStore, permission)}
                        <div
                            class="nav-item"
                            class:active={$location === `/${view}`}
                            on:click={() => showView(view)}
                            on:keydown={(e) => e.key === 'Enter' && showView(view)}
                            role="button"
                            tabindex="0"
                        >
                            <span class="nav-icon"><i class="fas {icon}"></i></span>
                            {label}
                        </div>
                    {/if}
                {/each}
            {/if}
        {/each}
    </nav>

    <div class="sidebar-footer">
        <div class="user-avatar">{userInitial}</div>
        <div class="user-info">
            <div class="user-name">{user?.name ?? ''}</div>
            <div class="user-email">{user?.email ?? ''}</div>
        </div>
        <span class="logout-btn" on:click={onLogout} title="Cerrar sesión">
            <i class="fas fa-sign-out-alt"></i>
        </span>
    </div>

</div>

<div class="mobile-topbar">
    <div class="mobile-logo">
        <img src="images/brand.png" alt="Logisbox" class="brand-logo-img brand-logo-img--compact" />
        <span class="mobile-logo-text">Admin</span>
    </div>
    <button class="hamburger-btn" on:click={() => mobileOpen = true} aria-label="Abrir menú">
        <i class="fas fa-bars"></i>
    </button>
</div>

{#if mobileOpen}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="drawer-backdrop" on:click={() => mobileOpen = false}></div>

    <div class="drawer" transition:fly={{ x: -260, duration: 220 }}>

        <div class="drawer-header">
            <div class="drawer-logo">
                <img src="images/brand.png" alt="Logisbox" class="brand-logo-img brand-logo-img--compact" />
                <span class="drawer-logo-text">Admin</span>
            </div>
            <button class="drawer-close" on:click={() => mobileOpen = false} aria-label="Cerrar menú">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <nav class="drawer-nav">
            {#each navSections as section}
                {#if sectionHasItems(section)}
                    <div class="nav-section-label">{section.label}</div>
                    {#each section.items as { view, permission, label, icon }}
                        {#if isPermission($adminStore, permission)}
                            <div
                                class="nav-item"
                                class:active={$location === `/${view}`}
                                on:click={() => showView(view)}
                                on:keydown={(e) => e.key === 'Enter' && showView(view)}
                                role="button"
                                tabindex="0"
                            >
                                <span class="nav-icon"><i class="fas {icon}"></i></span>
                                {label}
                            </div>
                        {/if}
                    {/each}
                {/if}
            {/each}
        </nav>

        <div class="drawer-footer">
            <div class="user-avatar">{userInitial}</div>
            <div class="user-info">
                <div class="user-name">{user?.name ?? ''}</div>
                <div class="user-email">{user?.email ?? ''}</div>
            </div>
            <span class="logout-btn" on:click={onLogout} title="Cerrar sesión">
                <i class="fas fa-sign-out-alt"></i>
            </span>
        </div>

    </div>
{/if}
